import { useSelector } from "react-redux";
import useMovieTrailer from "../hooks/useMovieTrailer";

const VideoBackground = ({ movieId }) => {
  const trailerVideo = useSelector((store) => store.movies?.trailerVideo);

  useMovieTrailer(movieId);

  return (
    <div className="w-screen">
      <iframe
        className="w-screen object-cover aspect-video"
        src={
          "https://www.youtube.com/embed/" +
          trailerVideo?.key  +
          "?&autoplay=1&mute=1"
         
        }
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen="true" frameBorder="0"
      ></iframe>
    </div>
  );
};
export default VideoBackground;
